import { render, staticRenderFns } from "./Scores.vue?vue&type=template&id=ab2affbc&scoped=true&"
import script from "./Scores.vue?vue&type=script&lang=ts&"
export * from "./Scores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2affbc",
  null
  
)

export default component.exports